import { GraphQLClient } from 'graphql-request';

const endpoint = process.env.REACT_APP_HYGRAPH_ENDPOINT;
const token = process.env.REACT_APP_HYGRAPH_TOKEN;

if (!endpoint) {
  throw new Error('REACT_APP_HYGRAPH_ENDPOINT is not configured');
}

export const hygraphClient = new GraphQLClient(endpoint, {
  headers: {
    ...(token && { authorization: `Bearer ${token}` }),
  },
});

export default hygraphClient;